import React from "react";

interface HeroSectionProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
  children?: React.ReactNode;
  minHeight?: string;
  alignment?: "left" | "center" | "right";
}

export function HeroSection({
  title,
  subtitle,
  backgroundImage = "/images/residential_roof.jpg",
  children,
  minHeight = "pt-44 md:pb-32 pb-28",
  alignment = "center",
}: HeroSectionProps) {
  const textAlignment = {
    left: "text-left",
    center: "text-center",
    right: "text-right",
  }[alignment];

  return (
    <div className="bg-dark-green-700 text-white relative">
      {/* Background image with opacity */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url('${backgroundImage}')`, opacity: "0.3" }}
      ></div>

      {/* Dark gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-dark-green-900 to-dark-green-700 opacity-80"></div>

      {/* Content with relative positioning */}
      <div
        className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${minHeight} relative z-10`}
      >
        <div className={textAlignment}>
          <h1
            className="text-4xl md:text-5xl heading-primary mb-6"
            data-animate="fade-down"
          >
            {title}
          </h1>

          {subtitle && (
            <p
              className="text-xl md:text-2xl text-gray-100 max-w-3xl mx-auto"
              data-animate="fade-up"
              data-delay="200"
            >
              {subtitle}
            </p>
          )}

          {children && (
            <div className="mt-8" data-animate="fade-up" data-delay="300">
              {children}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
